module.exports = __webpack_public_path__ + "static/sf.3218528c.png";